/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_Link_ExpiredInputs */

const en_invite_x15_link_expired = /** @type {(inputs: Invite_X15_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That sign-in link has expired. Send yourself a new one below.`)
};

/** @type {(inputs: Invite_X15_Link_ExpiredInputs) => LocalizedString} */
const ar_invite_x15_link_expired = en_invite_x15_link_expired;

/** @type {(inputs: Invite_X15_Link_ExpiredInputs) => LocalizedString} */
const he_invite_x15_link_expired = en_invite_x15_link_expired;

/** @type {(inputs: Invite_X15_Link_ExpiredInputs) => LocalizedString} */
const ur_invite_x15_link_expired = en_invite_x15_link_expired;

/** @type {(inputs: Invite_X15_Link_ExpiredInputs) => LocalizedString} */
const es_invite_x15_link_expired = en_invite_x15_link_expired;

/** @type {(inputs: Invite_X15_Link_ExpiredInputs) => LocalizedString} */
const fr_invite_x15_link_expired = en_invite_x15_link_expired;

/** @type {(inputs: Invite_X15_Link_ExpiredInputs) => LocalizedString} */
const de_invite_x15_link_expired = en_invite_x15_link_expired;

/** @type {(inputs: Invite_X15_Link_ExpiredInputs) => LocalizedString} */
const pt_invite_x15_link_expired = en_invite_x15_link_expired;

/** @type {(inputs: Invite_X15_Link_ExpiredInputs) => LocalizedString} */
const hi_invite_x15_link_expired = en_invite_x15_link_expired;

/** @type {(inputs: Invite_X15_Link_ExpiredInputs) => LocalizedString} */
const bn_invite_x15_link_expired = en_invite_x15_link_expired;

/**
* | output |
* | --- |
* | "That sign-in link has expired. Send yourself a new one below." |
*
* @param {Invite_X15_Link_ExpiredInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_link_expired = /** @type {((inputs?: Invite_X15_Link_ExpiredInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_Link_ExpiredInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_link_expired(inputs)
	if (locale === "he") return he_invite_x15_link_expired(inputs)
	if (locale === "ur") return ur_invite_x15_link_expired(inputs)
	if (locale === "es") return es_invite_x15_link_expired(inputs)
	if (locale === "fr") return fr_invite_x15_link_expired(inputs)
	if (locale === "de") return de_invite_x15_link_expired(inputs)
	if (locale === "pt") return pt_invite_x15_link_expired(inputs)
	if (locale === "hi") return hi_invite_x15_link_expired(inputs)
	if (locale === "bn") return bn_invite_x15_link_expired(inputs)
	return /** @type {LocalizedString} */ ("That sign-in link has expired. Send yourself a new one below.")
});